<template>
  <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/standardEvaluation/index.vue